import React from 'react';
import i18n from 'i18next';
import { isString } from '@ma/cube/cjs/functions';

export default class I18n extends React.Component {
  static t = (keys, options) => i18n.t(keys, options);

  render() {
    const { as = 'p', children, ...props } = this.props;
    console.log(this.props);
    if (isString(children) && i18n.exists(children)) {
      return React.createElement(as, props, i18n.t(children));
    }
    return React.createElement(as, props, children);
  }
}
